import Vue from 'vue'
import Vuex from 'vuex'
import authModule from '@/store/modules/auth'
import * as customerModule from '@/store/modules/customer'
import * as businessModule from '@/store/modules/business'
import * as categoryModule from '@/store/modules/category'
import * as itemModule from '@/store/modules/item'
import * as userModule from '@/store/modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    authModule,
    customerModule,
    businessModule,
    categoryModule,
    itemModule,
    userModule,
  },
  state: {
    loaded: false,
    showSnack: false,
    alert: {
      type: "success",
      show: false,
      message: "",
      color: "primary",
    },
  },
  mutations: {
		
    SET_SHOW(state, payload) {
      state.show = payload;
    },
    SET_LOADED(state, payload) {
      state.loaded = payload;
    },
    SET_SHOWSNACK: (state, value) => {
      state.showSnack = value;
    },
    SET_ALERT_MESSAGE: (state, data) => {
      state.alert.type = data.type;
      state.alert.show = data.show;
      state.alert.message = data.message;
      state.alert.color = data.color;
      setTimeout(() => {
        state.alert.type = "success";
        state.alert.show = false;
        state.alert.message = "";
        state.alert.color = "primary";
      }, data.timeout);
    },
  },
  actions: {
    setLoaded({ commit }, value) {
      commit("SET_LOADED", value);
    },
    setShowSnackbar({ commit }, value) {
      commit("SET_SHOWSNACK", value);
    },
  },
  getters: {
    showComponent: (state) => {
      return state.showItems;
    },
  },
});
